(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/redux/actions.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/redux/actions.js');
"use strict";


const {
  EMAIL,
  GREETING,
  NAME,
  PHONE,
  DATE,
  TIME,
  DATE_AND_TIME,
  DATE_TIME_AND_NAME,
  DATE_SELECTOR,
  PERSONAL_GREETING
} = svs.tickets_giftshop.constants.names;
const {
  INPUT_SET_PERSONAL_GREETING,
  INPUT_SET_GREETING,
  INPUT_SET_NAME,
  INPUT_SET_EMAIL,
  INPUT_SET_PHONE,
  INPUT_SET_RECEIVER_TYPE,
  INPUT_SET_DATE,
  INPUT_SET_TIME,
  INPUT_SET_DATE_AND_TIME,
  INPUT_SET_DATE_TIME_AND_NAME,
  SET_DATE_SELECTOR,
  FORM_CLEAR
} = svs.tickets_giftshop.gift.giftform.actiontypes;
const setDateAction = date => ({
  type: INPUT_SET_DATE,
  payload: date
});
const setTimeAction = time => ({
  type: INPUT_SET_TIME,
  payload: time
});
const formClearAction = () => ({
  type: FORM_CLEAR
});
const inputChangeAction = _ref => {
  let {
    field,
    value
  } = _ref;
  const action = {
    payload: value
  };
  switch (field) {
    case EMAIL:
      action.type = INPUT_SET_EMAIL;
      break;
    case PERSONAL_GREETING:
      action.type = INPUT_SET_PERSONAL_GREETING;
      break;
    case GREETING:
      action.type = INPUT_SET_GREETING;
      break;
    case NAME:
      action.type = INPUT_SET_NAME;
      break;
    case PHONE:
      action.type = INPUT_SET_PHONE;
      break;
    case DATE:
      action.type = INPUT_SET_DATE;
      break;
    case TIME:
      action.type = INPUT_SET_TIME;
      break;
    case DATE_AND_TIME:
      action.type = INPUT_SET_DATE_AND_TIME;
      break;
    case DATE_TIME_AND_NAME:
      action.type = INPUT_SET_DATE_TIME_AND_NAME;
      break;
    case DATE_SELECTOR:
      action.type = SET_DATE_SELECTOR;
      break;
    default:
      break;
  }
  return action;
};
const receiverTypeChangeAction = _ref2 => {
  let {
    value
  } = _ref2;
  return {
    type: INPUT_SET_RECEIVER_TYPE,
    payload: value
  };
};
svs.tickets_giftshop.gift.giftform.actions = {
  inputChangeAction,
  receiverTypeChangeAction,
  formClearAction,
  setDateAction,
  setTimeAction
};

 })(window);